/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   let cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise, it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

let cur_position = $(window).scrollTop();
if (cur_position > 0) {
  if (
    !$(".product_transparent_wrap #shopify-section-header .header").hasClass(
      "scrolled"
    )
  ) {
    $(".product_transparent_wrap #shopify-section-header .header").addClass(
      "scrolled"
    );
  }
} else {
  $(".product_transparent_wrap #shopify-section-header .header").addClass(
    "trans_header"
  );
}

$(window).on("scroll", function (event) {
  // deltaY obviously records vertical scroll, deltaX and deltaZ exist too.
  // this condition makes sure it's vertical scrolling that happened

  // wheeled up
  if ($(this).scrollTop() < 100) {
    if (
      $(".product_transparent_wrap #shopify-section-header .header").hasClass(
        "scrolled"
      )
    ) {
      $(
        ".product_transparent_wrap #shopify-section-header .header"
      ).removeClass("scrolled");
      $(".product_transparent_wrap #shopify-section-header .header").addClass(
        "trans_header"
      );
    }
  } else {
    // wheeled down
    if (
      !$(".product_transparent_wrap #shopify-section-header .header").hasClass(
        "scrolled"
      )
    ) {
      $(".product_transparent_wrap #shopify-section-header .header").addClass(
        "scrolled"
      );
      $(
        ".product_transparent_wrap #shopify-section-header .header"
      ).removeClass("trans_header");
    }
  }
});

$(document).ready(function () {
  $(".product_progress_bar_show_center").last().css("left", "calc(50% - 25px)");

  $(".product__info .sizze_select_btn").click(function () {
    // Prevent interaction with disabled/out-of-stock sizes
    if ($(this).hasClass("is-disabled")) {
      return false;
    }

    let select_size;
    let current_select = $(this);
    select_size = $(this).attr("id");

    $(".product__info .sizze_select_btn").each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }
    });

    $(this).addClass("selected");

    $(
      ".product__info .bold_option_radio .bold_option_value_element input"
    ).each(function (index) {
      if (select_size === $(this).val()) {
        $(this).attr("checked", true);
      }
    });
  });

  /* checking selected color */
  $(document).on("click", ".caret_color_options .option", function (event) {
    let selected_val = $(this).find(".color_val").text();
    let selected_val_nospace = selected_val.replace(/[_\W]+/g, "");
    let parent_widget = $(this).parents(".product-item").find("option");

    $(".caret_color_options .option").each(function (index) {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
      }
      $(this).attr("aria-checked", "false");
      updateSwatchAriaLabel($(this), false);
    });

    $(parent_widget).each(function (index) {
      if ($(this).val() === selected_val_nospace) {
        $(this).prop("selected", true);
      }
    });

    $(this).addClass("checked");
    $(this).attr("aria-checked", "true");
    updateSwatchAriaLabel($(this), true);

    // save the variant id
    let variant_id;

    // change image
    let color_parent_widget = $(this)
      .parents(".product-item")
      .find(".color-swatch");
    $(color_parent_widget.find(".color-swatch__item")).each(function (index) {
      let nospace_color = $(this)
        .text()
        .replace(/[_\W]+/g, "");
      if (nospace_color === selected_val_nospace) {
        variant_id = $(this)
          .parent()
          .find(".color-swatch__radio")
          .attr("data-variant-id");
        $(this).trigger("click");
      }
    });

    // set variant id to form section
    $(this)
      .parents(".product-item")
      .find(".shopify-product-form input[name='id']")
      .val(variant_id);

    // change select option images
    let color_img = $(this).find(".color_image").html();

    $(this)
      .parents(".product-item")
      .find(".caret_selected_color_value")
      .html(color_img);
  });

  /* select size option */
  $(document).on("click", ".option .sizze_select_btn", function (event) {
    // Prevent interaction with disabled/out-of-stock sizes
    if ($(this).hasClass("is-disabled")) {
      event.preventDefault();
      return false;
    }

    let select_size;
    let current_select = $(this);
    select_size = $(this).attr("data-target");

    $(".option .sizze_select_btn").each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }
      $(this).attr("aria-checked", "false");
      updateSwatchAriaLabel($(this), false);
    });

    $(this).addClass("selected");
    $(this).attr("aria-checked", "true");
    updateSwatchAriaLabel($(this), true);

    // value display
    let current_size_val = $(this).attr("data-target");
    $(this)
      .parents(".actions")
      .find(".caret_selected_size_value")
      .text(current_size_val);

    // Bold app select option check
    let size_parent_widget = $(this)
      .parents(".product-item")
      .find(".product-form__buy-buttons");
    $(
      size_parent_widget.find(
        ".bold_option_radio .bold_option_value_element input"
      )
    ).each(function (index) {
      if (select_size === $(this).val()) {
        $(this).attr("checked", true);
      }
    });

    $(this)
      .parents(".variants")
      .find(".caret_size")
      .css("background", "#f1f1f1");
    $(this).parents(".variants").find(".caret_size").css("color", "#06038d");
    $(this)
      .parents(".variants")
      .find(".caret_size svg polyline")
      .css("stroke", "#06038d");
  });

  /* recommend product bag */
  $(document).on("click", ".recommend_add-to-bag", function () {
    let size_parent_widget = $(this)
      .parents(".row ")
      .find(".variants .recommend_field.selected .recommend_size_select_btn ");
    let selected_size = false;
    let variant_id = "";

    $(size_parent_widget).each(function (index) {
      if ($(this).hasClass("selected")) {
        selected_size = true;
        variant_id = $(this).attr("data-variant");
      }
    });

    if (!selected_size) {
      $(".select-notification").slideDown("slow", function () {
        // Animation complete.
      });

      setTimeout(function () {
        $(".select-notification").slideUp("slow", function () {
          // Animation complete.
        });
      }, 2000);

      // change background of size section
      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("background", "#ffbe9f");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("color", "#8a2d00");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size svg polyline")
        .css("stroke", "#8a2d00");
    } else {
      // clicking the add to bug button
      $(this)
        .parents(".product-item")
        .find(".shopify-product-form input[name='id']")
        .val(variant_id);
      $(this)
        .parents(".product-item")
        .find(".shopify-product-form .product-form__add-button")
        .trigger("click");

      let cur_size_value_element = $(this)
        .parent()
        .find(".variants .recommend_field.selected .caret_selected_size_value");

      $(".recommend_field .caret_selected_size_value").each(function (index) {
        let size_value_element = $(this);

        if (
          cur_size_value_element.length == size_value_element.length &&
          cur_size_value_element.length ==
          cur_size_value_element.filter(size_value_element).length
        ) {
          // They are equal
        } else {
          $(this).text("SIZE");
        }
      });
    }
  });

  /* recommend size button click */
  $(document).on("click", ".recommend_option", function () {
    let product_target = $(this).attr("data-target");
    let parent_widget = $(this).parents(".variants ").find(".recommend_field");
    let featured_widtet = $(this)
      .parents(".recommend_product-item")
      .find(".product-item__aspect-ratio");
    let cur_price = $(this).attr("data-price");
    let cur_com_price = $(this).attr("data-com-price");

    // change button value
    if (cur_com_price) {
      $(this)
        .parents(".recommend_product-item")
        .find(".add-to-bag")
        .html(
          "ADD TO BAG -" +
          "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
          cur_price +
          "</div> <div class='display_price_oncartbtn price--compare'>" +
          cur_com_price +
          "</div></div>"
        );
    } else {
      $(this)
        .parents(".recommend_product-item")
        .find(".add-to-bag")
        .html(
          "ADD TO BAG -" +
          " <div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
          cur_price +
          "</div> </div>"
        );
    }

    $(parent_widget).each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }

      $(parent_widget).find(".caret_size").css("background", "#f1f1f1");
      $(parent_widget).find(".caret_size").css("color", "#06038d");
      $(parent_widget)
        .find(".caret_size svg polyline")
        .css("stroke", "#06038d");
      $(parent_widget)
        .find(".caret_size .caret_selected_size_value")
        .text("SIZE");
    });

    $(parent_widget).each(function (index) {
      if ($(this).attr("data-parent") == product_target) {
        $(this).addClass("selected");
      }
    });

    $(featured_widtet).each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }
    });

    $(featured_widtet).each(function (index) {
      if ($(this).attr("product_id") == product_target) {
        $(this).addClass("selected");
      }
    });
  });

  /* click special button */
  $(document).on("click", ".add-to-bag-special", function () {
    let variant_id;
    variant_id = $(this).data("variant_id");

    $(this)
      .parent()
      .parent()
      .parent()
      .parent(".product-item")
      .find(".shopify-product-form input[name='id']")
      .val(variant_id);
    $(this)
      .parent()
      .parent()
      .parent()
      .parent(".product-item")
      .find(".product-form__add-button")
      .trigger("click");
  });

  /* click add to cart button on collection and recommend product */
  $(document).on("click", ".add-to-bag-normal", function () {
    let size_parent_widget = $(this)
      .parents(".row ")
      .find(".variants .sizze_select_btn");
    let selected_size = false;
    let variant_id = "";

    $(size_parent_widget).each(function (index) {
      if ($(this).hasClass("selected")) {
        selected_size = true;
        variant_id = $(this).attr("data-variant");
      }
    });

    if (!selected_size) {
      $(".select-notification").slideDown("slow", function () {
        // Animation complete.
      });

      setTimeout(function () {
        $(".select-notification").slideUp("slow", function () {
          // Animation complete.
        });
      }, 2000);

      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("background", "#ffbe9f");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("color", "#8a2d00");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size svg polyline")
        .css("stroke", "#8a2d00");
    } else {
      // clicking the add to bug button
      $(this)
        .parent()
        .parent()
        .parent()
        .parent(".product-item")
        .find(".shopify-product-form input[name='id']")
        .val(variant_id);
      $(this)
        .parent()
        .parent()
        .parent()
        .parent(".product-item")
        .find(".product-form__add-button")
        .trigger("click");

      let cur_size_value_element = $(this)
        .parent(".product_select_option_wrap")
        .find(".variants .caret_selected_size_value");

      $(".product-item .caret_selected_size_value").each(function (index) {
        let size_value_element = $(this);

        if (
          cur_size_value_element.length == size_value_element.length &&
          cur_size_value_element.length ==
          cur_size_value_element.filter(size_value_element).length
        ) {
          // They are equal
        } else {
          $(this).text("SIZE");
        }
      });
    }
  });

  /* mobile add to cart button on product page */
  $(document).on("click", ".add-to-bag_main_pro", function () {
    if (this.classList.contains("simple-sticky-cta")) {
      simpleAddToBag(this);
      return false;
    }
    if (this.classList.contains('no-size')) { return false }

    $(this)
      .parents(".product-form")
      .find(".product-form__add-button ")
      .trigger("click");
  });

  // Adding mega menu image item
  $(".link--faded").each(function (index) {
    if ($(this).text() === "Slides") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/Slides_083f3393-dddf-4a7b-8f02-cd3053d10f22.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Slip-Ons") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/Slipons_b23d9dfd-e332-4899-95ca-18b5a5fbf991.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }

    // This collection is no longer being sold
    /*if ($(this).text() === "Boots") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/boots_e4296f16-25ab-4e6a-8cb3-9d1e405fbc0d.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }*/

    if ($(this).text() === "Kids") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/Kids_1dcf8d06-5d8f-449b-a891-4890cffb0906.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Socks") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/sock1.svg'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Candles") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/candle1.svg'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Gift Cards" || $(this).text() === "Shop All") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/gift.svg'>"
      );
      $(this).css("margin-left", "0px");
    }

    // This collection is no longer being sold
    /*if ($(this).text() === "Indoor Slippers") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/indoorslide_a5180233-f544-4f4e-b74f-fcfc99aac89b.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }*/
  });

  // change variant name on swatch name and trigger Klaviyo once if this swatch is for Size
  $(document).on("click", ".product__info .variant-swatch__item", function (event) {
    try {
      var isUserInitiated = !!(event && (event.originalEvent || event.isTrusted));
      if (isUserInitiated && document.body && document.body.classList.contains('rosa-pdp-template')) {
        var $opt = $(this).closest('.product-form__option');
        var titleText = ($opt.find('.product-form__option-name').text() || '').trim().toLowerCase();
        if (titleText.indexOf('size') !== -1 && !window.__klSizeClickFired) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'SFCsHT']);
          window.__klSizeClickFired = true;
        }
      }
    } catch (e) { }

    let selected_variant = $(this).find(".visually-hidden").text();
    $(".swatch_name_btn").text(selected_variant);
  });

  // If size is presented as a dropdown (combo-box), trigger Klaviyo once on first user selection
  $(document).on('click', '.combo-box__option-item', function (event) {
    try {
      var isUserInitiated = !!(event && (event.originalEvent || event.isTrusted));
      if (isUserInitiated && document.body && document.body.classList.contains('rosa-pdp-template') && !window.__klSizeClickFired) {
        var $combo = $(this).closest('.combo-box');
        var titleText = ($combo.find('.combo-box__title').text() || '').trim().toLowerCase();
        if (titleText.indexOf('size') !== -1) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'SFCsHT']);
          window.__klSizeClickFired = true;
        }
      }
    } catch (e) { }
  });

  // Fallback for native select change (if combo-box not used)
  $(document).on('change', '.select-wrapper select[name^="option"]', function (event) {
    try {
      if (document.body && document.body.classList.contains('template-product') && !window.__klSizeClickFired) {
        var $optWrap = $(this).closest('.product-form__option, .select-wrapper');
        var titleText = (
          $optWrap.find('.product-form__option-name').text() ||
          $optWrap.find('.combo-box__title').text() || ''
        ).trim().toLowerCase();
        if (titleText.indexOf('size') !== -1) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'SFCsHT']);
          window.__klSizeClickFired = true;
        }
      }
    } catch (e) { }
  });

  // scroll details
  $(document).on("click", "#details", function (e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $(".product-content_progress_wrap").offset().top - 200,
      },
      300,
      "linear"
    );
  });

  /*if ($(".kids-size-guide-container")) {
    if ($(".juniors-size-guide-container")) {
      $(".kids-size-guide-container").append($('.juniors-size-guide-container .inner-size-guide-container'))
    }
  }*/

  // Accessibility for Size Guide dialogs: announce open/close, trap focus, restore focus
  (function initSizeGuideA11y() {
    var state = (window.__sizeGuideA11y = window.__sizeGuideA11y || {
      lastTrigger: null,
      activeModal: null,
      keyHandlerBound: false
    });

    function ensureLiveRegion() {
      if (!document.getElementById('a11y-status')) {
        var sr = document.createElement('div');
        sr.id = 'a11y-status';
        sr.setAttribute('aria-live', 'polite');
        sr.setAttribute('aria-atomic', 'true');
        sr.className = 'visually-hidden';
        // Inline fallback in case .visually-hidden is missing
        sr.style.position = 'absolute'; sr.style.width = '1px'; sr.style.height = '1px'; sr.style.margin = '-1px'; sr.style.border = '0'; sr.style.padding = '0'; sr.style.clip = 'rect(0 0 0 0)'; sr.style.overflow = 'hidden';
        document.body.appendChild(sr);
      }
      return document.getElementById('a11y-status');
    }

    function announce(msg) {
      try {
        var live = ensureLiveRegion();
        live.textContent = '';
        setTimeout(function () { live.textContent = msg; }, 10);
      } catch (e) { }
    }

    function getFocusable($root) {
      var focusables = $root.find('a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])')
        .filter(':visible');
      return focusables;
    }

    function bindKeyHandlers() {
      if (state.keyHandlerBound) return;
      state.keyHandlerBound = true;
      $(document).on('keydown.sizeguide', function (e) {
        if (!state.activeModal) return;
        var $modal = $(state.activeModal);
        if (!$modal.hasClass('open')) return;
        // ESC closes
        if (e.key === 'Escape' || e.keyCode === 27) {
          e.stopPropagation();
          closeModal($modal);
          return;
        }
        // Trap focus with Tab
        if (e.key === 'Tab' || e.keyCode === 9) {
          var $focusables = getFocusable($modal);
          if ($focusables.length === 0) { e.preventDefault(); return; }
          var first = $focusables[0];
          var last = $focusables[$focusables.length - 1];
          var active = document.activeElement;
          if (e.shiftKey) {
            if (active === first || !$modal[0].contains(active)) {
              e.preventDefault();
              $(last).focus();
            }
          } else {
            if (active === last) {
              e.preventDefault();
              $(first).focus();
            }
          }
        }
      });
    }

    function openModal($modal, trigger) {
      state.lastTrigger = trigger || document.activeElement;
      state.activeModal = $modal[0];
      bindKeyHandlers();

      if (!$modal.hasClass('open')) {
        $modal.addClass('open');
      }

      var title = $modal.find('h2, [id^="size-guide-title-"]').first();
      var titleText = (title.length && typeof title.text === 'function') ? title.text().trim() : 'Size Guide';

      if (state.lastTrigger && state.lastTrigger.setAttribute) {
        try { state.lastTrigger.setAttribute('aria-expanded', 'true'); } catch (e) { }
      }

      // ADA Remediation: Move focus into the popup window.
      // Using a timeout ensures the transition has started and the element is ready to receive focus.
      // Focusing on the title (h2) ensures the screen reader announces the modal purpose
      // and starts at the top of the content.
      setTimeout(function () {
        if (title.length) {
          title.focus();
        } else {
          var $focusables = getFocusable($modal);
          if ($focusables.length) {
            $focusables.first().focus();
          } else {
            $modal.attr('tabindex', '-1').focus();
          }
        }
      }, 100);

      announce('Opened size guide: ' + titleText);
    }

    function closeModal($modal) {
      if ($modal && $modal.hasClass('open')) {
        $modal.removeClass('open');
      }
      if (state.lastTrigger && state.lastTrigger.focus) {
        try { state.lastTrigger.setAttribute('aria-expanded', 'false'); } catch (e) { }
        try { state.lastTrigger.focus(); } catch (e) { }
      }
      announce('Closed size guide');
      state.activeModal = null;
    }

    window.__openSizeGuideModal = openModal;
    window.__closeSizeGuideModal = closeModal;

    // Close via the X button inside container
    $(document).on('click', '.close-icon', function () {
      var $container = $(this).closest('#size-guide-container, .kids-size-guide-container, .juniors-size-guide-container, .socks-size-guide-container');
      if ($container.length) {
        closeModal($container);
      }
    });

    function handleTriggerActivate(e, $target, $modal) {
      var isKeyboard = e.type === 'keydown';
      if (isKeyboard) {
        var key = e.key || e.keyCode;
        if (!(key === 'Enter' || key === ' ' || key === 13 || key === 32)) return;
        e.preventDefault();
      }
      openModal($modal, $target[0]);
    }

    // Main size guide trigger
    $(document).on('click keydown', '#size-guide', function (e) {
      var $modal = $('#size-guide-container');
      if ($modal.length) { handleTriggerActivate(e, $(this), $modal); }
    });

    // Optional variant triggers if present
    $(document).on('click keydown', '#kids-guide', function (e) {
      var $modal = $('.kids-size-guide-container');
      if ($modal.length) { handleTriggerActivate(e, $(this), $modal); }
    });

    $(document).on('click keydown', '#juniors-guide', function (e) {
      var $modal = $('.juniors-size-guide-container');
      if ($modal.length) { handleTriggerActivate(e, $(this), $modal); }
    });

    $(document).on('click keydown', '#socks-guide', function (e) {
      var $modal = $('.socks-size-guide-container');
      if ($modal.length) { handleTriggerActivate(e, $(this), $modal); }
    });
  })();

  // collection page details mobile
  $(document).on("click", ".details_dont_btn", function () {
    let selected_dot_name = $(this).attr("id");

    $(".details_slider_logo ").each(function (index) {
      let current_id = $(this).attr("id");

      if (selected_dot_name == "details_dot_1") {
        if (current_id == "details_slider_comfort") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });
            $(this).addClass("details_selected");
          }
        }
      } else if (selected_dot_name == "details_dot_2") {
        if (current_id == "details_slider_triple") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });
            $(this).addClass("details_selected");
          }
        }

        if (current_id == "details_slider_water") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });
            $(this).addClass("details_selected");
          }
        }
      } else if (selected_dot_name == "details_dot_3") {
        if (current_id == "details_slider_recycled") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });

            $(this).addClass("details_selected");
          }
        }
      } else if (selected_dot_name == "details_dot_4") {
        if (current_id == "details_slider_animal") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });

            $(this).addClass("details_selected");
          }
        }
      }
    });
  });

  $(document).on(
    "click",
    ".details_slider_logos .details_slider_logo",
    function () {
      let selected_slider_name = $(this).attr("id");

      if (selected_slider_name == "details_slider_comfort") {
        $("#details_dot_1").trigger("click");
      } else if (selected_slider_name == "details_slider_triple") {
        $("#details_dot_2").trigger("click");
      } else if (selected_slider_name == "details_slider_recycled") {
        $("#details_dot_3").trigger("click");
      }
    }
  );

  $(document).on(
    "click",
    ".details_slider_scenario_logos .details_slider_logo",
    function () {
      let selected_slider_name = $(this).attr("id");

      if (selected_slider_name == "details_slider_comfort") {
        $("#details_dot_1").trigger("click");
      } else if (selected_slider_name == "details_slider_water") {
        $("#details_dot_2").trigger("click");
      } else if (selected_slider_name == "details_slider_recycled") {
        $("#details_dot_3").trigger("click");
      } else if (selected_slider_name == "details_slider_animal") {
        $("#details_dot_4").trigger("click");
      }
    }
  );

  // guid scroll
  let lastScrollLeft = 0;

  $(".size-scrollbar").scroll(function (event) {
    let curent_ScrollLeft = $(this).scrollLeft();

    if (curent_ScrollLeft > lastScrollLeft) {
      $("#size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".kids-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".socks-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".inner-size-guide-container[data-size-type='juniors'] .sizes").scrollLeft(curent_ScrollLeft);
    } else {
      $("#size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".kids-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".socks-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".inner-size-guide-container[data-size-type='juniors'] .sizes").scrollLeft(curent_ScrollLeft);
    }

    lastScrollLeft = curent_ScrollLeft;
  });

  let size_lastScrollLeft = 0;

  $("#size-guide-container .sizes").scroll(function (event) {
    let curent_ScrollLeft = $(this).scrollLeft();

    if (curent_ScrollLeft > size_lastScrollLeft) {
      $(".size-scrollbar").scrollLeft(curent_ScrollLeft);
    } else {
      $(".size-scrollbar").scrollLeft(curent_ScrollLeft);
    }

    size_lastScrollLeft = curent_ScrollLeft;
  });

  setDisableStateForKids();

  // remain price on cart button
  $(document).on("click", ".block-swatch__item", function (event) {
    // Fire Klaviyo form open on first size click (PDP only); ignore programmatic clicks
    try {
      var isUserInitiated = !!(event && (event.originalEvent || event.isTrusted));
      if (isUserInitiated && document.body && document.body.classList.contains('rosa-pdp-template')) {
        if (!window.__klSizeClickFired) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'SFCsHT']);
          window.__klSizeClickFired = true;
        }
      }
    } catch (e) { }

    const $swatch = $(this);
    const $productForm = $swatch.parents(".product-form_wrap");
    const $addToBagButton = $productForm.find(".add-to-bag_main_pro");

    // Extract data attributes
    const data = {
      price: $swatch.attr("data-price"),
      comparePrice: $swatch.attr("data-com-price"),
      preorder: $swatch.attr("data-preorder"),
      variantId: $swatch.attr("data-variant"),
      sizeCode: $swatch.attr("data-sizecode"),
      inventory: $swatch.attr("data-inventory"),
      collectionProducts: JSON.parse($productForm.find(".product_collection_data").text()),
    };

    // Handle size code cookie
    if (data.sizeCode) {
      Cookies.set("sizecode", data.sizeCode);
    }

    // Update button content
    updateAddToBagButton($swatch, $addToBagButton, data);

    // Update sticky CTA
    updateStickyCTA();
    updateStickyCTAPrice();
    try {
      const variant = findVariantById(
        data.collectionProducts,
        parseInt(data.variantId, 10)
      );
      syncPdpStickyCtaVariantTitle(variant);
    } catch (e) {
      syncPdpStickyCtaVariantTitle(null);
    }

    // Handle inventory status
    updateInventoryStatus(data.inventory);

    // Update Color Swatch States
    updateColorSwatchStates(data);
    setDisableStateForKids();
  });

  // Accessibility: keep aria-selected in sync for color and size swatches on PDP
  function updateAriaSelectedForSwatchGroup($input) {
    try {
      if (!$input || !$input.length) return;
      var $group = $input.closest('.product-form__option');
      if (!$group.length) $group = $input.closest('.product-form_wrap');

      // Reset all swatch labels in this group
      $group
        .find('label.color-swatch__item, label.block-swatch__item, label.variant-swatch__item')
        .each(function () {
          var $l = $(this);
          $l.attr('aria-selected', 'false')
            // For proper SR announcement with role="radio", keep aria-checked in sync, too
            .attr('aria-checked', 'false');
          updateSwatchAriaLabel($l, false);
        });

      // Set true on the selected input's label
      var id = $input.attr('id');
      if (id) {
        var $selectedLabel = $group.find('label[for="' + id + '"]');
        $selectedLabel
          .attr('aria-selected', 'true')
          .attr('role', 'radio')
          .attr('aria-checked', 'true');
        updateSwatchAriaLabel($selectedLabel, true);
      }
    } catch (e) { /* no-op */ }
  }

  function updateSwatchAriaLabel($label, isSelected) {
    try {
      var $vh = $label.find('.visually-hidden');
      var baseValue = '';
      if ($vh.length) {
        baseValue = $vh.text().trim();
      } else {
        baseValue = $label.text().trim();
      }
      if (!baseValue) return;

      // Clean up any previous status suffix to avoid "Red - selected - selected"
      baseValue = baseValue.split(' - ')[0];

      // Check for sold out status in the existing aria-label or data-inventory
      var currentAriaLabel = $label.attr('aria-label') || '';
      var isSoldOut = currentAriaLabel.toLowerCase().indexOf('sold out') !== -1;

      var statusText = isSelected ? 'selected' : 'not selected';
      var finalLabel = baseValue + ' - ' + statusText;

      if (isSoldOut) {
        finalLabel += ' - sold out';
      }

      $label.attr('aria-label', finalLabel);
    } catch (e) { /* no-op */ }
  }

  // On change of any swatch radio, update aria-selected
  $(document).on('change', '.color-swatch__radio, .block-swatch__radio, .variant-swatch__radio', function () {
    updateAriaSelectedForSwatchGroup($(this));
  });

  // Initialize on page load for pre-checked inputs
  (function initAriaSelectedOnLoad() {
    try {
      $('.color-swatch__radio:checked, .block-swatch__radio:checked, .variant-swatch__radio:checked').each(function () {
        updateAriaSelectedForSwatchGroup($(this));
      });
    } catch (e) { /* no-op */ }
  })();

  // Also update on theme variant change event if fired
  document.addEventListener('variant:changed', function (evt) {
    try {
      var $context = $(evt.target || document);
      $context.find('.color-swatch__radio:checked, .block-swatch__radio:checked, .variant-swatch__radio:checked').each(function () {
        updateAriaSelectedForSwatchGroup($(this));
      });
    } catch (e) { /* no-op */ }
  }, true);

  // Make block/color/variant swatch labels keyboard-focusable and operable
  // This addresses the issue where block-swatch elements are not reachable via Tab
  window.enhanceSwatchKeyboardAccessibility = (context) => {
    try {
      var $root = context ? $(context) : $(document);
      // Ensure swatch groups have the appropriate ARIA role

      // Remove radios from the tab order so labels become the only tab stops
      $root
        .find('.block-swatch__radio, .color-swatch__radio, .variant-swatch__radio')
        .attr('tabindex', '-1');

      // Target all label swatch items
      var $labels = $root.find('label.block-swatch__item, label.color-swatch__item, label.variant-swatch__item');
      $labels.each(function () {
        var $label = $(this);
        var forId = $label.attr('for');
        // Use getElementById to avoid reliance on CSS.escape (not supported in some browsers)
        var inputEl = forId ? document.getElementById(forId) : null;
        var $input = inputEl ? $(inputEl) : $();
        var disabledByWrapper = $label.closest('.block-swatch.is-disabled, .variant-swatch.is-disabled').length > 0;
        var isAriaDisabled = $label.is('[aria-disabled="true"]');
        // Skip if explicitly disabled or inside a disabled swatch wrapper
        var isDisabled = disabledByWrapper || isAriaDisabled;
        if (isDisabled) {
          // Ensure disabled items are not tabbable
          $label.attr('tabindex', '-1');
          $label.attr('aria-disabled', 'true');
        } else {
          // Ensure enabled labels are tabbable regardless of any existing tabindex from previous state
          $label.attr('tabindex', '0');
          $label.attr('aria-disabled', 'false');
        }

        // Set ARIA role and state for radios on labels
        $label.attr('role', 'radio');
        if ($input && $input.length) {
          var checked = $input.is(':checked');
          $label.attr('aria-checked', checked ? 'true' : 'false');
          updateSwatchAriaLabel($label, checked);
        }
      });
    } catch (e) { /* no-op */ }
  }

  // Initial enhancement on DOM ready
  $(function () {
    enhanceSwatchKeyboardAccessibility(document);
  });

  // Re-apply when variants change (DOM may be re-rendered)
  document.addEventListener('variant:changed', function (evt) {
    enhanceSwatchKeyboardAccessibility(evt.target || document);
  }, true);

  // Also re-apply on section load (Shopify editor, dynamic loads)
  document.addEventListener('shopify:section:load', function (evt) {
    enhanceSwatchKeyboardAccessibility(evt.target || document);
  });

  // Keyboard activation for swatch labels: Enter or Space selects the option without submitting the form
  $(document).on('keydown', 'label.block-swatch__item, label.color-swatch__item, label.variant-swatch__item', function (e) {
    var key = e.key;
    var isActivation = (key === 'Enter' || key === ' ' || key === 'Spacebar');
    var isArrow = (key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown');
    if (!isActivation && !isArrow) return;

    var $current = $(this);
    var $group = $current.closest('.block-swatch-list, .variant-swatch-list, .color-swatch-list');
    // Do not act on disabled items
    if ($current.closest('.block-swatch.is-disabled, .variant-swatch.is-disabled').length) {
      return;
    }

    // Prevent page scroll and implicit form submit
    e.preventDefault();
    e.stopPropagation();

    var activateLabel = function (labelEl) {
      try {
        var forId = labelEl.getAttribute('for');
        var input = forId ? document.getElementById(forId) : null;
        if (input && !input.disabled) {
          input.click();
          // Update ARIA states within the group
          if ($group && $group.length) {
            $group.find('label.block-swatch__item, label.color-swatch__item, label.variant-swatch__item')
              .attr('aria-checked', 'false');
          }
          labelEl.setAttribute('aria-checked', 'true');
        } else {
          labelEl.click();
        }
        labelEl.focus();
      } catch (_) { }
    };

    if (isActivation) {
      activateLabel(this);
      return;
    }

    // Arrow navigation: move to previous/next enabled label in the same group
    var $all = $group.find('label.block-swatch__item, label.color-swatch__item, label.variant-swatch__item').filter(function () {
      return $(this).attr('tabindex') !== '-1';
    });
    var index = $all.index($current);
    if (index === -1) return;

    var nextIndex = index;
    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      nextIndex = (index - 1 + $all.length) % $all.length;
    } else if (key === 'ArrowRight' || key === 'ArrowDown') {
      nextIndex = (index + 1) % $all.length;
    }
    var nextEl = $all.get(nextIndex);
    if (nextEl) {
      activateLabel(nextEl);
    }
  });

  let productSwatchGrid = document.querySelector('.featured_images_wrap .inner-container');
  if (productSwatchGrid) {
    productSwatchGrid.addEventListener('click', function (event) {
      let $target = event.target;
      let swatchItem = $target.closest('.featured_images_item');
      let swatchLink = swatchItem.querySelector('a');

      if (window.location.pathname.includes('juniors')) {
        if (!swatchLink.href.includes('kids') && !swatchItem.classList.contains('disabled-swatch')) {
          window.location = swatchLink.href;
        }
      } else {
        if (!swatchItem.classList.contains('disabled-swatch')) {
          window.location = swatchLink.href;
        }
      }
    });
  }

  function findVariantById(products, variantId) {
    return products.flatMap(product => product.variants).find(variant => variant.id === variantId) || null;
  }

  function createVariantMap(products) {
    const variantMap = new Map();
    products.forEach(product => {
      product.variants.forEach(variant => {
        variantMap.set(variant.id, variant);
      });
    });
    return variantMap;
  }

  function setDisableStateForKids() {
    if (!window.location.pathname.includes('juniors')) return;

    const $productForm = $(".product-form_wrap");
    if (!$productForm) return;
    const collectionProducts = JSON.parse($productForm.find(".product_collection_data").text())
    if (typeof collectionProducts !== 'object') return;

    let filteredProducts = collectionProducts.filter(product =>
      product.title.includes('Kids')
    );

    filteredProducts.forEach((product) => {
      let productSwatch = document.querySelector(`.featured_images_item[data_id="${product.id}"]`)

      if (productSwatch && product.title.includes('Kids')) {
        productSwatch.classList.add('disabled-swatch');
      }
    });
  }

  function updateColorSwatchStates(data) {
    if (typeof data !== 'object') return;
    const variantMap = createVariantMap(data.collectionProducts);
    const currentVariant = findVariantById(data.collectionProducts, parseInt(data.variantId));

    const { option1, option2, option3 } = currentVariant;

    data.collectionProducts.forEach(product => {
      let productSwatch = document.querySelector(`.featured_images_item[data_id="${product.id}"]`)
      if (productSwatch) {
        productSwatch.classList.remove('disabled-swatch');

        let swatchLink = productSwatch.querySelector('a');
        if (swatchLink) {
          let currentAriaLabel = swatchLink.getAttribute('aria-label');
          if (currentAriaLabel && currentAriaLabel.includes(' - sold out')) {
            swatchLink.setAttribute('aria-label', currentAriaLabel.replace(' - sold out', ''));
          }
        }
      }
    });

    let filteredProducts = data.collectionProducts.filter(product =>
      product.variants.some(v =>
        v.option1 === option1 &&
        v.option2 === option2 &&
        v.option3 === option3 &&
        !v.available // Filter unavailable variants
      )
    );

    if (filteredProducts.length > 0) {
      filteredProducts.forEach(product => {
        let productSwatch = document.querySelector(`.featured_images_item[data_id="${product.id}"]`)
        if (productSwatch) {
          productSwatch.classList.add('disabled-swatch');

          let swatchLink = productSwatch.querySelector('a');
          if (swatchLink) {
            let currentAriaLabel = swatchLink.getAttribute('aria-label');
            if (currentAriaLabel && !currentAriaLabel.includes('sold out')) {
              swatchLink.setAttribute('aria-label', currentAriaLabel + ' - sold out');
            }
          }
        }
      });
    }
  }

  function updateAddToBagButton($swatch, $addToBagButton, data) {
    $addToBagButton.removeClass("no-size");

    if ($swatch.parent().hasClass("is-disabled")) {
      renderOutOfStockButton($addToBagButton, data.variantId);
      return;
    }

    if (data.comparePrice) {
      renderButtonWithComparePrice($addToBagButton, data);
    } else {
      renderButtonWithSinglePrice($addToBagButton, data);
    }

  }

  function renderOutOfStockButton($button, variantId) {
    $button.html(
      `<div class='no_stock_message' data-variant='${variantId}'>NOTIFY ME WHEN BACK IN STOCK</div>`
    );
  }

  function renderButtonWithComparePrice($button, data) {
    const buttonText = data.preorder === "no_prorder" ? "ADD TO BAG" : "PREORDER NOW";
    $button.html(
      `${buttonText}  &nbsp;<div class='display_price_set'>
            <div class='display_price_oncartbtn'>${data.price}</div>
            <div class='display_price_oncartbtn price--compare'>${data.comparePrice}</div>
        </div>`
    );
  }

  function renderButtonWithSinglePrice($button, data) {
    const buttonText = data.preorder === "no_prorder" ? "ADD TO BAG" : "PREORDER NOW";
    $button.html(
      `${buttonText}  <div class='display_price_set'>
            <div class='display_price_oncartbtn'> &nbsp;${data.price}</div>
        </div>`
    );
  }

  function updateStickyCTA() {
    const $mainAddToBag = $(".product-form_wrap form .add-to-bag_main_pro").first();
    const $stickyCTA = $(".simple-sticky-cta.no-size");
    if ($mainAddToBag.find(".no_stock_message").length) {
      $stickyCTA
        .removeClass("no-size")
        .attr("data-variant-selected", "true")
        .html($mainAddToBag.html());
    } else {
      $stickyCTA
        .removeClass("no-size")
        .attr("data-variant-selected", "true");
      const mainCopy = $mainAddToBag.find(".copy").first().text().trim();
      const stickyText = mainCopy || "add to bag";
      $(".simple-sticky-cta span.state").text(stickyText);
    }
  }

  function updateInventoryStatus(inventory) {
    $(".backorder_message").css("display", inventory === "sold_out" ? "block" : "none");
  }

  $(document).on(
    "click",
    ".show_desktop_bag_btn .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");

      if (!cur_variant_id) {
        let pathname = window.location.href;
        const myArray = pathname.split("?variant=");

        cur_variant_id = parseInt(myArray[1]);
      }

      $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger")
        .attr("data-variant-id", cur_variant_id);
      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger");

      collection_bis_button[0].click();
    }
  );

  $(document).on(
    "click",
    ".show_mobile_bag_btn .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");

      if (!cur_variant_id) {
        let pathname = window.location.href;
        const myArray = pathname.split("?variant=");

        cur_variant_id = parseInt(myArray[1]);
      }

      $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger")
        .attr("data-variant-id", cur_variant_id);
      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger");

      collection_bis_button[0].click();
    }
  );

  // Product select on Collection page
  $(document).on(
    "click",
    ".product_select_option_wrap .sizze_select_btn.recommend_size_select_btn",
    function (event) {
      let cur_price = $(this).attr("data-price");
      let cur_com_price = $(this).attr("data-com-price");
      let cur_preorder = $(this).attr("data-preorder");
      let cur_variant_id = $(this).attr("data-variant");

      if ($(this).hasClass("is-disabled")) {
        $(this)
          .parents(".product_select_option_wrap")
          .find(".add-to-bag")
          .html(
            "<div class='no_stock_message' data-variant='" +
            cur_variant_id +
            "'>NOTIFY ME WHEN BACK IN STOCK</div>"
          );
        $(this)
          .parents(".product-item.product-card")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", true);
      } else {
        if (cur_com_price) {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                cur_price +
                "</div> <div class='display_price_oncartbtn price--compare'>" +
                cur_com_price +
                "</div></div>"
              );
          } else {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                cur_price +
                "</div> <div class='display_price_oncartbtn price--compare'>" +
                cur_com_price +
                "</div></div>"
              );
          }
        } else {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                "<div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                cur_price +
                "</div> </div>"
              );
          } else {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                "<div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                cur_price +
                "</div> </div>"
              );
          }
        }

        // $(this).parents(".product_select_option_wrap").find(".add-to-bag").html("ADD TO BAG - " + "<div class='display_price_oncartbtn'> &nbsp;" + cur_price + "</div>");
        $(this)
          .parents(".product-item.product-card")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", false);
      }

      let cur_variant_inventory = $(this).attr("data-inventory");
      if (cur_variant_inventory == "sold_out") {
        $(this)
          .parents(".product-item.product-card")
          .find(".backorder_message_plp")
          .css("display", "block");
      } else {
        $(this)
          .parents(".product-item.product-card")
          .find(".backorder_message_plp")
          .css("display", "none");
      }
    }
  );

  // stock button click
  $(document).on(
    "click",
    ".product_select_option_wrap .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");

      $(this)
        .parent()
        .parent()
        .find(".collection_bis_trigger")
        .attr("data-variant-id", cur_variant_id);
      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".collection_bis_trigger");

      collection_bis_button[0].click();
    }
  );

  // recommend product item
  $(document).on(
    "click",
    ".recommend_product-item .sizze_select_btn.recommend_size_select_btn",
    function (event) {
      let cur_price = $(this).attr("data-price");
      let cur_com_price = $(this).attr("data-com-price");
      let cur_preorder = $(this).attr("data-preorder");
      let cur_variant_id = $(this).attr("data-variant");

      if ($(this).hasClass("is-disabled")) {
        $(this)
          .parents(".recommend_product-item")
          .find(".add-to-bag")
          .html(
            "<div class='no_stock_message' data-variant='" +
            cur_variant_id +
            "'>NOTIFY ME WHEN BACK IN STOCK</div>"
          );
        $(this)
          .parents(".recommend_product-item")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", true);
      } else {
        if (cur_com_price) {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                cur_price +
                "</div> <div class='display_price_oncartbtn price--compare'>" +
                cur_com_price +
                "</div></div>"
              );
          } else {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                cur_price +
                "</div> <div class='display_price_oncartbtn price--compare'>" +
                cur_com_price +
                "</div></div>"
              );
          }
        } else {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                " <div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                cur_price +
                "</div> </div>"
              );
          } else {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                " <div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                cur_price +
                "</div> </div>"
              );
          }
        }

        // $(this).parents(".recommend_product-item").find(".add-to-bag").html("ADD TO BAG - " + "<div class='display_price_oncartbtn'> &nbsp;" + cur_price + "</div>");
        $(this)
          .parents(".recommend_product-item")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", false);
      }

      let cur_variant_inventory = $(this).attr("data-inventory");
      if (cur_variant_inventory == "sold_out") {
        $(this)
          .parents(".product-item.product-card.recommend_product-item")
          .find(".backorder_message_recom")
          .css("display", "block");
      } else {
        $(this)
          .parents(".product-item.product-card.recommend_product-item")
          .find(".backorder_message_recom")
          .css("display", "none");
      }
    }
  );

  $(document).on(
    "click",
    ".recommend_add-to-bag .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");
      $(this)
        .parent()
        .parent()
        .find(".recommend_field.selected .recommend_bis_trigger")
        .attr("data-variant-id", cur_variant_id);

      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".recommend_field.selected .recommend_bis_trigger");
      collection_bis_button[0].click();
    }
  );

  /* select variant and change values and change url */
  function ChangeUrl(page, url) {
    if (typeof history.pushState != "undefined") {
      let obj = { Page: page, Url: url };
      history.pushState(obj, obj.Page, obj.Url);
    } else {
      alert("Browser does not support HTML5.");
    }
  }

  /*$(document).on("click", ".featured_images_item", function (event) {
    let product_id = $(this).attr("data_id");
    let product_url = $(this).attr("data_url");

    ChangeUrl("Page1", product_url);

    // change form
    $(".product-form_wrap").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change slider
    $(".product-thumbnails_wrap").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change meta images
    $(".product_meta_image_wrap").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change mete images slider
    $(".product_meta_carousel").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change product description
    $(".hide_product-tabs_tab").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change care instructions
    $(".care_instructions").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    /!* hide and show preorder message *!/
    $(".backorder_message").css("display", "none");

    $(".product-form_wrap.selected .block-swatch").each(function (index) {
      let cur_variant_inventory = $(this)
        .find(".block-swatch__radio")
        .attr("data-inventory");

      if (
        cur_variant_inventory == "sold_out" &&
        $(this).find(".block-swatch__radio").is(":checked")
      ) {
        $(this).find(".block-swatch__item").click();
      }
    });

    updateStickyCTAPrice();
  });*/

  /* hover change variant name */
  $(".featured_images_item").hover(
    function () {
      let select_title = $(
        "#selected_product_form .featured_images_item.selected"
      ).attr("data_title");
      let cur_title = $(this).attr("data_title");
      let title_color = cur_title.split(" - ");

      $(".swatch_name_btn").text(`Color: ${title_color[title_color.length - 1]}`);
    },
    function () {
      let select_title = $(
        "#selected_product_form .featured_images_item.selected"
      ).attr("data_title");
      let cur_title = $(this).attr("data_title");
      let title_color = select_title.split(" - ");

      $(".swatch_name_btn").text(`Color: ${title_color[title_color.length - 1]}`);
    }
  );

  /* Same position after redirect */
  /*$(document).on("click",".featured_images_item a",function(event) {
        let cur_position = $(window).scrollTop();

        localStorage.setItem('cur_position', cur_position);
    });

    $(document).ready(function(){
        if (localStorage.getItem('cur_position')) {
            // $(window).scrollTop(localStorage.getItem('cur_position'));
            $('html').animate({scrollTop:localStorage.getItem('cur_position')});
            localStorage.removeItem('cur_position');
        }
    });*/

  $(document).on("click", ".mobile-toolbar__item--filters", function (event) {
    $(".product-facet__filters.drawer").attr("open", "");
  });

  $(document).on("click", ".product-facet__filters", function (event) {
    let cur_position = $(window).scrollTop();
    localStorage.setItem("cur_position", cur_position);
  });

  /* add white background when mouse scroll on product page */
  $(document).ready(function () {
    let cur_position = $(window).scrollTop();

    if (cur_position > 0) {
      if (
        !$(
          ".product_transparent_wrap #shopify-section-header .header"
        ).hasClass("scrolled")
      ) {
        $(".product_transparent_wrap #shopify-section-header .header").addClass(
          "scrolled"
        );
      }
    }

    // no stock label to add to cart button
    $(".product-form__option-selector .block-swatch__radio").each(function (
      index
    ) {
      if ($(this).is(":checked")) {
        if ($(this).parent().hasClass("is-disabled")) {
          $(this)
            .parents(".product-form_wrap")
            .find(".add-to-bag_main_pro")
            .html(
              "<div class='no_stock_message'>NOTIFY ME WHEN BACK IN STOCK</div>"
            );
        }
      }
    });

    // add drawer class
    let win_width = $(window).width();

    if (win_width < 1200 && win_width > 1000) {
      $(".product-facet__filters").addClass("drawer ");
      $(".product-facet__filters").addClass("drawer--from-left");
    }

    // go to scroll policy terms
    let pathname = window.location.pathname;
    let page_url = window.location.href;
    let hostname = window.location.hostname;
    let last_part = "";

    if (pathname == "/pages/policies") {
      let parts = page_url.split("="),
        last_part = parts[parts.length - 1];

      if (last_part) {
        let link_target = "#ghost-" + last_part;

        $("html, body").animate(
          {
            scrollTop: $(link_target).offset().top,
          },
          700
        );
      }
    }

    // master products redirect
    if (pathname == "/collections/all") {
      window.location.href = "/collections/shop-all";
    }

    // master products redirect
    if (pathname == "/products/pelli") {
      window.location.href = "/products/pelli-indigo-coffee";
    }

    if (pathname == "/products/esto") {
      window.location.href = "/products/esto-chestnut-cord-lily";
    }

    if (pathname == "/products/gehry") {
      window.location.href = "/products/gehry-jet-black-lily";
    }

    if (pathname == "/products/guru") {
      window.location.href = "/products/guru-indigo-coffee";
    }

    if (pathname == "/products/guru-sherp") {
      window.location.href = "/products/guru-sherp-olive-night-waffle-oatmeal";
    }

    if (pathname == "/products/nomad") {
      window.location.href = "/products/nomad-goat-lily";
    }

    if (pathname == "/products/cino") {
      window.location.href = "/products/cino-mid-waffle-suede-goat-lily";
    }

    if (pathname == "/products/draper") {
      window.location.href = "/products/draper-waffle-chestnut-marshmallow";
    }

    if (pathname == "/products/scenario-kids-coffee") {
      window.location.href = "/products/scenario-kids-pb-coffee";
    }

    if (pathname == "/products/scenario-juniors") {
      window.location.href = "/products/scenario-juniors-pb-bone-white";
    }

    if (pathname == "/products/keychain") {
      window.location.href = "/products/lusso-cloud-keychain-bone-malt";
    }

    // faq page
    if (
      $(this).scrollTop() >=
      $(window).height() - $(".fixed-menu").height() - 160
    ) {
      $(".fixed-menu").addClass("fixed");
    } else {
      $(".fixed-menu").removeClass("fixed");
    }

    let scrollTop = $(this).scrollTop();

    // Faq page
    if ($("#ghost-placing-an-order").length != 0) {
      let topDistance_placing = $("#ghost-placing-an-order").offset().top;
      if (topDistance_placing - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "placing-an-order") {
            $(this).addClass("selected");
          }
        });
      }

      let topDistance_shipping = $("#ghost-shipping").offset().top;
      if (topDistance_shipping - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "shipping") {
            $(this).addClass("selected");
          }
        });
      }

      let topDistance_returns = $("#ghost-returns-exchanges").offset().top;
      if (topDistance_returns - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "returns-exchanges") {
            $(this).addClass("selected");
          }
        });
      }

      let topDistance_products = $("#ghost-our-products").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "our-products") {
            $(this).addClass("selected");
          }
        });
      }
    }

    // polices page
    if ($("#ghost-privacy-policy").length != 0) {
      let topDistance_products = $("#ghost-privacy-policy").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "privacy-policy") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-terms-of-service").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "terms-of-service") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-shipping").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "shipping") {
            $(this).addClass("selected");
          }
        });
      }
    }
  });

  // Faq page
  $(document).scroll(function () {
    if (
      $(this).scrollTop() >=
      $(window).height() - $(".fixed-menu").height() - 160
    ) {
      $(".fixed-menu").addClass("fixed");
    } else {
      $(".fixed-menu").removeClass("fixed");
    }

    let scrollTop = $(this).scrollTop();
    let bodyElement = document.body;

    // Faq page
    if (bodyElement.classList.contains("page-faq")) {
      updateFAQSection($, scrollTop);
    }

    // polices page
    if ($("#ghost-privacy-policy").length != 0) {
      let topDistance_products = $("#ghost-privacy-policy").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "privacy-policy") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-terms-of-service").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "terms-of-service") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-shipping").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "shipping") {
            $(this).addClass("selected");
          }
        });
      }
    }
  });

  // go to location
  $(document).on("click", ".fixed-menu .link", function (event) {
    let current_state = $(this).data("target");

    $(".fixed-menu .link").each(function (index) {
      $(this).removeClass("selected");
    });

    $(this).addClass("selected");
    let link_target = "#ghost-" + current_state;

    $("html, body").animate(
      {
        scrollTop: $(link_target).offset().top,
      },
      700
    );
  });

  $(document).on(
    "click",
    ".tertiary-section .options .option",
    function (event) {
      let current_state = $(this).data("target");

      $(".tertiary-section .options .option").each(function (index) {
        $(this).removeClass("checked");
      });

      $(this).addClass("checked");
      let link_target = "#ghost-" + current_state;

      $("html, body").animate(
        {
          scrollTop: $(link_target).offset().top + 10,
        },
        700
      );
    }
  );

  $(window).resize(function () {
    let win_width = $(window).width();
    if (win_width < 1200 && win_width > 1000) {
      $(".product-facet__filters").addClass("drawer ");
      $(".product-facet__filters").addClass("drawer--from-left");
    }

    /*let more_colors_state = (getCookie('more_colors_state') === 'true');
    let moreColorsButton = document.querySelector('[data-more-colors-btn]');

    console.log('more_colors_state:', more_colors_state)
    console.log('moreColorsButton:', moreColorsButton)*/
  });

  let products_on_page = "";
  let next_url = "";
  let load_more_btn = "";
  let load_more_spinner = "";

  $(document).on("click", ".load-more__btn", function (event) {
    products_on_page = $(".products-on-page");
    next_url = products_on_page.data("next-url");
    load_more_btn = $(".load-more__btn");
    load_more_spinner = $(".load-more__spinner");

    loadMoreProducts();
  });

  function loadMoreProducts() {
    $.ajax({
      url: next_url,
      type: "GET",
      dataType: "html",
      beforeSend: function () {
        load_more_btn.hide();
        load_more_spinner.show();
      },
    }).done(function (next_page) {
      load_more_spinner.hide();

      let new_products = $(next_page).find(".products-on-page");
      let new_url = new_products.data("next-url");

      if (new_url) load_more_btn.show();

      next_url = new_url;
      products_on_page.data("next-url", next_url);
      products_on_page.append(new_products.html());
    });
  }

  let flag_val = "true";
  let ajaxinateLoop = document.querySelector("#AjaxinateLoop");

  $(window).on("scroll", function () {
    if (!ajaxinateLoop) {
      return false;
    }

    if (
      $(window).scrollTop() >=
      $(ajaxinateLoop).offset().top +
      $(ajaxinateLoop).outerHeight() -
      window.innerHeight
    ) {
      if (flag_val === "true") {
        $(".load-more__btn").trigger("click");
        flag_val = "false";
      }

      if (flag_val === "false") {
        if ($(".load-more__btn").css("display") != "none") {
          flag_val = "true";
        }
      }

      // alert('You reached the end of the DIV');
    }
  });

  $(document).on(
    "click",
    ".questions-section .content.question",
    function (event) {
      let current_state = false;
      if ($(this).hasClass("open")) {
        current_state = true;
      }

      $(".questions-section .content.question").each(function (index) {
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).find(".body").css("height", "0");
        }
      });

      if (current_state) {
        $(this).removeClass("open");
        $(this).find(".body").css("height", "0");
      } else {
        $(this).addClass("open");

        let p_height1 = 0;
        $(this)
          .find(".body p")
          .each(function (index) {
            p_height1 = p_height1 + $(this).height();
          });

        let p_height = $(this).find(".body p").height();

        $(this)
          .find(".body")
          .css("height", p_height1 + "px");
      }
    }
  );

  /*  $("#slide_fliky1").flickity({
    // options
    cellAlign: "center",
    contain: true,
    fade: true,
  });*/

  // add class to klaviyo form first image
});

let bodyEle = document.querySelector("body");
if (bodyEle.classList.contains("pdp-template")) {
  let lastKnownScrollPosition = 0;

  function updateStickyCTAVisibility() {
    lastKnownScrollPosition = window.scrollY;
    let selectedFormWrap = document.querySelector(".product-form_wrap");
    if (!selectedFormWrap) {
      return;
    }
    let dataId = selectedFormWrap.getAttribute("data_id");
    if (typeof dataId !== "string") {
      return;
    }
    let isDesktop = window.innerWidth >= 1001;
    let staticAtcSelector = isDesktop
      ? `.show_desktop_bag_btn[data-parent="product-card-${dataId}"]`
      : `.show_mobile_bag_btn[data-parent="product-card-${dataId}"]`;
    let staticAtc = document.querySelector(staticAtcSelector);
    if (!staticAtc) {
      return;
    }
    let siteFooter = document.querySelector("#shopify-section-footer");
    if (!siteFooter) {
      return;
    }

    let staticAtcRect = staticAtc.getBoundingClientRect();
    let siteFooterOffset = siteFooter.offsetTop;
    let pdpStickyCTA = document.querySelector(".pdp-sticky-cta");

    if (!pdpStickyCTA) {
      return;
    }

    let isMainAddToBagVisible;
    if (document.body.hasAttribute("data-sticky-cta-offscreen")) {
      const headerCut = 141;
      const vh = window.innerHeight;
      isMainAddToBagVisible =
        staticAtcRect.bottom > headerCut &&
        staticAtcRect.top < vh;
    } else {
      isMainAddToBagVisible = staticAtcRect.bottom >= 141;
    }
    let isFooterVisible = lastKnownScrollPosition >= siteFooterOffset - 800;

    let shouldHide =
      (isMainAddToBagVisible && !isFooterVisible) ||
      (isFooterVisible && !isMainAddToBagVisible);

    pdpStickyCTA.classList.toggle("pdp-sticky-cta--hidden", shouldHide);
  }

  document.addEventListener("scroll", updateStickyCTAVisibility);
  window.addEventListener("resize", updateStickyCTAVisibility);
  updateStickyCTAVisibility();
}

function updateFAQSection($, scrollTop) {
  let placingAnOrderAnchor = document.querySelector("#ghost-placing-an-order");
  let shippingAnchor = document.querySelector("#ghost-shipping");
  let returnsExchangesAnchor = document.querySelector(
    "#ghost-returns-exchanges"
  );
  let ourProductsAnchor = document.querySelector("#ghost-our-products");
  let fixedMenuLinks = $(".fixed-menu .link");

  if (!placingAnOrderAnchor || !fixedMenuLinks.length) {
    return false;
  }

  let topDistance_placing = $(placingAnOrderAnchor).offset().top;
  if (topDistance_placing - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "placing-an-order") {
        $(this).addClass("selected");
      }
    });
  }

  let topDistance_shipping = $(shippingAnchor).offset().top;

  if (topDistance_shipping - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "shipping") {
        $(this).addClass("selected");
      }
    });
  }

  let topDistance_returns = $(returnsExchangesAnchor).offset().top;
  if (topDistance_returns - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "returns-exchanges") {
        $(this).addClass("selected");
      }
    });
  }

  let topDistance_products = $(ourProductsAnchor).offset().top;
  if (topDistance_products - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "our-products") {
        $(this).addClass("selected");
      }
    });
  }
}

function simpleAddToBag(simpleAddToBagButton) {
  if (!simpleAddToBagButton) {
    return false;
  }

  let variantSelected = simpleAddToBagButton.dataset.variantSelected;
  if (typeof variantSelected !== "string") {
    return false;
  }

  if (variantSelected === "true") {
    let mainAddToBag = document.querySelector(
      ".product-form_wrap form .add-to-bag_main_pro"
    );

    if (!mainAddToBag) {
      return false;
    }

    let noStockMsg = mainAddToBag.querySelector(".no_stock_message");
    if (noStockMsg) {
      noStockMsg.click();
    } else {
      mainAddToBag.click();
    }
  } else if (variantSelected === "false") {
    let blockSwatchList = getCurrentBlockSwatchList();

    if (!blockSwatchList) {
      return false;
    }
    let blockSwatchListOffsetTop = blockSwatchList.offsetTop - 400;
    let blockSwatchListOffsetLeft = blockSwatchList.offsetLeft - 400;

    window.scrollTo({
      top: blockSwatchListOffsetTop,
      left: blockSwatchListOffsetLeft,
      behavior: "smooth",
    });
  }
}

function updateStickyCTA(swatch) {
  if (!swatch) {
    return false;
  }

  let pdpStickyCTA = document.querySelector(".pdp-sticky-cta");
  if (!pdpStickyCTA) {
    return false;
  }
  let simpleAddToBagButton;

  if (pdpStickyCTA.dataset.ctaType === "simple") {
    document.querySelectorAll(".simple-sticky-cta").forEach(function (el) {
      el.setAttribute("data-variant-selected", "true");
    });
  }
}

function updateStickyCTAPrice() {
  let mainAddToBag = document.querySelector(
    ".product-form_wrap form .add-to-bag_main_pro"
  );
  if (!mainAddToBag) {
    return false;
  }

  let mainPriceSet = mainAddToBag.querySelector(".display_price_set");
  if (!mainPriceSet) {
    return false;
  }

  let stickyPriceSets = document.querySelectorAll(".pdp-sticky-cta .display_price_set");
  if (!stickyPriceSets.length) {
    return false;
  }

  let priceHtml = mainPriceSet.innerHTML.replace(/\s+/g, " ").trim();
  stickyPriceSets.forEach(function (el) {
    el.innerHTML = priceHtml;
  });
}

function syncPdpStickyCtaMobileMeta() {
  const root = document.querySelector(".pdp-sticky-cta");
  if (!root) return;

  const meta = root.querySelector(".pdp-sticky-cta__mobile-meta");
  if (!meta) return;

  const colorOnly = root.querySelector(".pdp-sticky-cta__color-only");
  const variantSlot = root.querySelector(".pdp-sticky-cta__variant-slot");
  const variantTitle = root.querySelector(".pdp-sticky-cta__variant-title");

  const colorValue = colorOnly?.textContent?.replace(/\s+/g, " ").trim() || "";

  let sizeValue = "";
  if (variantSlot && variantTitle && !variantSlot.hidden) {
    sizeValue = variantTitle?.textContent?.replace(/\s+/g, " ").trim() || "";
  }

  const colorCell = root.querySelector(".pdp-sticky-cta__mobile-color");
  const sizeCell = root.querySelector(".pdp-sticky-cta__mobile-size");
  const colorValueEl = root.querySelector(".pdp-sticky-cta__mobile-color-value");
  const sizeValueEl = root.querySelector(".pdp-sticky-cta__mobile-size-value");

  let showColor = false;
  if (colorCell && colorValueEl && colorValue) {
    colorValueEl.textContent = colorValue;
    colorCell.hidden = false;
    showColor = true;
  } else if (colorCell) {
    colorCell.hidden = true;
  }

  let showSize = false;
  if (sizeCell && sizeValueEl && sizeValue) {
    sizeValueEl.textContent = sizeValue;
    sizeCell.hidden = false;
    showSize = true;
  } else if (sizeCell) {
    sizeCell.hidden = true;
  }

  meta.hidden = !showColor && !showSize;
}

function syncPdpStickyCtaVariantTitle(variant) {
  try {
    const root = document.querySelector(
      '.pdp-sticky-cta[data-show-variant-title="true"]'
    );
    if (!root) return;

    const el = root.querySelector(".pdp-sticky-cta__variant-title");
    if (!el) return;

    const variantSlot = root.querySelector(".pdp-sticky-cta__variant-slot");
    const mainAtc = document.querySelector(
      ".product-form_wrap .add-to-bag_main_pro"
    );
    const awaitingSize =
      mainAtc && mainAtc.classList.contains("no-size");

    if (awaitingSize) {
      el.textContent = "";
      if (variantSlot) variantSlot.hidden = true;
      return;
    }

    if (variantSlot) variantSlot.hidden = false;

    let v = variant;
    if (
      (!v || !v.title) &&
      window.storedProductVariants &&
      window.storedProductVariants.selectedVariant
    ) {
      v = window.storedProductVariants.selectedVariant;
    }

    if (v && v.title) {
      el.textContent = v.title;
    }
  } finally {
    syncPdpStickyCtaMobileMeta();
  }
}

function getCurrentBlockSwatchList() {
  let selectedProductFormWrap = document.querySelector(".product-form_wrap");
  if (!selectedProductFormWrap) {
    return false;
  }

  let blockSwatchList =
    selectedProductFormWrap.querySelector(".block-swatch-list");
  if (!blockSwatchList) {
    return false;
  }

  return blockSwatchList;
}

$(function () {
  //js for size type buttons (mens/womans) on new pdp
  //store current block-swatch in array
  let mens_swatches = $(".block-swatch.men").clone(true).show();
  let womens_swatches = $(".block-swatch.women").clone(true).show();
  let active = "men";

  //console.log(mens_swatches);

  $("[data-size-type-btn]").on("click", function (e) {
    let _this = $(this);
    let btnLabel = $(this).text().replace(/\s+/g, " ").trim();
    let currentPathname = window.location.pathname;
    let $container = _this.closest(".size-type-buttons");
    let isTextStyle = $container.length && $container.attr("data-size-type-style") === "text";

    if (btnLabel.includes('Juniors') || btnLabel.includes('Kids')) {
      let correspondingHandle = _this.data("correspondingHandle");
      console.log('correspondingHandle:', correspondingHandle);

      $container.find("[data-size-type-btn]")
        .removeClass("tw-bg-lusso-blue tw-text-white active-size-type size-type-btn--active");

      if (isTextStyle) {
        _this.addClass("size-type-btn--active active-size-type");
      } else {
        _this.addClass("tw-bg-lusso-blue tw-text-white active-size-type");
      }

      if (currentPathname.includes('scenario-juniors')) {
        if (btnLabel.includes('Little Kids')) {
          window.location = correspondingHandle;
        }
      } else if (currentPathname.includes('scenario-kids')) {
        if (btnLabel.includes('Big Kids')) {
          window.location = correspondingHandle;
        }
      }
    } else {
      let currentState = $(".add-to-bag_main_pro").each(function () {
        //console.log($(this).html());

        $(this)
          .addClass("no-size")
          .html($(this).html().replace("ADD TO BAG", "SELECT A SIZE"));
      });
      $(".simple-sticky-cta")
        .addClass("no-size")
        .find(".state")
        .text("SELECT A SIZE")
        .off("click");

      syncPdpStickyCtaVariantTitle(null);

      $container.find("[data-size-type-btn]")
        .removeClass("tw-bg-lusso-blue tw-text-white active-size-type size-type-btn--active");

      if (isTextStyle) {
        $(this).addClass("size-type-btn--active active-size-type");
      } else {
        $(this).addClass("tw-bg-lusso-blue tw-text-white active-size-type");
      }

      let size_type = $(this).attr("data-size-type");

      if (size_type !== active) {
        $(".block-swatch-list").html("");

        if (size_type === "women") {
          $(womens_swatches).clone(true).appendTo(".block-swatch-list");
        } else {
          $(mens_swatches).clone(true).appendTo(".block-swatch-list");
        }

        active = size_type;
        $("[data-active-size-type]").find("span").text(active);

        // Re-initialize keyboard navigation and ARIA after the swatch list is reconstructed
        try {
          var listEl = document.querySelector('.block-swatch-list');
          if (typeof enhanceSwatchKeyboardAccessibility === 'function' && listEl) {
            enhanceSwatchKeyboardAccessibility(listEl);
            // Sync aria-selected/aria-checked for any pre-checked radios in the new list
            $(listEl)
              .find('.color-swatch__radio:checked, .block-swatch__radio:checked, .variant-swatch__radio:checked')
              .each(function () {
                if (typeof updateAriaSelectedForSwatchGroup === 'function') {
                  updateAriaSelectedForSwatchGroup($(this));
                }
              });
          }
        } catch (e) { /* no-op */ }
      }

      setDataSizeTypeCookie();

      window.storedProductVariants._updateDisableSelectors();

      // After variants update their disabled/hidden state, re-apply keyboard accessibility
      // so that only enabled, visible swatches remain tabbable
      try {
        setTimeout(function () {
          var listEl = document.querySelector('.block-swatch-list');
          console.log('typeof enhanceSwatchKeyboardAccessibility:', typeof enhanceSwatchKeyboardAccessibility);
          console.log('listEl:', listEl);
          if (typeof enhanceSwatchKeyboardAccessibility === 'function' && listEl) {
            enhanceSwatchKeyboardAccessibility(listEl);
          }
        }, 100);
      } catch (e) { /* no-op */ }
    }
  });

  // Clear size cookie when landing on Rosa PDP so user starts fresh on this template
  try {
    if (document.body && document.body.classList.contains('rosa-pdp-template')) {
      if (window.Cookies && typeof Cookies.remove === 'function') {
        // Remove with default and explicit path to be safe
        Cookies.remove('sizecode');
        Cookies.remove('sizecode', { path: '/' });
      } else {
        // Fallback manual removal
        document.cookie = 'sizecode=; Max-Age=0; path=/';
      }
    }
  } catch (e) { }

  let sizecode = Cookies.get("sizecode");
  if (sizecode) {
    setTimeout(function () {
      $(`.block-swatch__item[data-sizecode="${sizecode}"]`).trigger("click");
      //console.log(`[data-sizecode="${sizecode}"]`);
    }, 123);
  }
  //js for more colors + toggle on new pdp
  $("[data-more-colors-btn]").on("click", function (e) {
    $(".featured_images_wrap").toggleClass("full");
    const symbol = $(this).find("span.btn-symbol").text();
    const label = $(this).find("span.btn-label").text();
    $(this)
      .find("span.btn-symbol")
      .text(symbol === "+" ? "-" : "+");
    $(this)
      .find("span.btn-label")
      .text(label === "More Colors" ? "Less Colors" : "More Colors");

    setMoreColorsCookie($, true);
  });

  //js for more images + toggle on new pdp
  $("[data-more-images-btn]").on("click", function (e) {
    $(".product__media-grid-list").toggleClass("full");
    const symbol = $(this).find("span.btn-symbol").text();
    const label = $(this).find("span.btn-label").text();
    $(this)
      .find("span.btn-symbol")
      .text(symbol === "+" ? "-" : "+");
    $(this)
      .find("span.btn-label")
      .text(label === "Show More" ? "Show Less" : "Show More");
  });

  checkForActiveSizeType($);
  checkForMoreColorsCookie($);

  // Accessibility: annotate external links that open in a new tab
  try {
    (function annotateExternalNewTabLinks() {
      var processedAttr = 'data-a11y-annotated';
      var srClass = 'visually-hidden';
      var noticeText = '(opens in new tab)';

      function isExternal(href) {
        if (!href) return false;
        // Consider protocol-relative
        var a = document.createElement('a');
        a.href = href;
        // When href is like "//example.com", browser sets protocol from page
        var host = a.host || '';
        if (!host) return false; // relative link
        // Treat lussocloud.com domains as internal
        if (/(^|\.)lussocloud\.com$/i.test(host)) return false;
        // Also treat current host as internal
        if (host === window.location.host) return false;
        return true;
      }

      function hasSrText(el) {
        return !!el.querySelector('span.' + srClass + ', .sr-only, .u-visually-hidden');
      }

      function processAnchor(anchor) {
        if (!anchor || anchor.getAttribute(processedAttr) === 'true') return;
        var href = anchor.getAttribute('href');
        var target = anchor.getAttribute('target');
        if (target !== '_blank') return;
        if (!isExternal(href)) return;

        // Prefer aria-label augmentation if present
        var aria = anchor.getAttribute('aria-label');
        if (aria && aria.toLowerCase().indexOf('opens in new tab') === -1) {
          anchor.setAttribute('aria-label', aria + ' ' + noticeText);
        } else if (!hasSrText(anchor)) {
          // Append visually hidden text if not already present
          var sr = document.createElement('span');
          sr.className = srClass;
          sr.textContent = noticeText;
          anchor.appendChild(sr);
        }

        anchor.setAttribute(processedAttr, 'true');
      }

      function scan() {
        var anchors = document.querySelectorAll('a[target="_blank"]:not([' + processedAttr + '="true"])');
        anchors.forEach(processAnchor);
      }

      // Initial run and on dynamic changes
      scan();
      var mo = new MutationObserver(function () { scan(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      // Also rescan on theme-specific events if available
      document.addEventListener('shopify:section:load', scan);
      document.addEventListener('shopify:section:unload', scan);
      document.addEventListener('shopify:section:select', scan);
      document.addEventListener('shopify:section:deselect', scan);
    })();
  } catch (e) { /* no-op */ }
});

// adding mobile menu image item
$(".mobile-nav.list--unstyled .mobile-nav__item .mobile-nav__link, .shop-all-links ul li a").each(
  function (index) {
    let _this = $(this);
    let span = _this.find("span");
    if (span.text() === "Slides") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[0]}' alt='Slides Shoes Icon'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if (span.text() === "Slip-Ons") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[4]}' alt='Slip-ons Shoes Icon'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    // This collection is no longer being sold
    /*if ($(this).text() === "Boots") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/boots_e4296f16-25ab-4e6a-8cb3-9d1e405fbc0d.svg?v=1697131765' alt='Boots icon'>"
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }*/

    if (span.text() === "Kids") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[3]}' alt='Kids Shoes Icon'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if (span.text() === "Socks") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/sock1.svg' alt='Socks icon'>"
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if (span.text() === "Candles") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/candle1.svg' alt='Candles icon'>"
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if (span.text() === "Gift Cards" || span.text() === "Accessories") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[5]}' alt='Accessories Icon'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if (span.text() === "House Slides" || span.text() === "Indoor") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[1]}' alt='Indoor Shoes Icon'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }
  }
);

const fliConfig = {
  childList: true,
  subtree: true
}

const fliCallback = (mutationsList, observer) => {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
      return addFilterLabelIcons();
    }
  });
}

if (document.body.classList.contains('collection_page')) {
  const fliObserver = new MutationObserver(fliCallback);
  fliObserver.observe(document.querySelector('#facet-main'), fliConfig);

  addFilterLabelIcons();
}

function addFilterLabelIcons() {
  let filterLabelIcon = document.querySelector('.filter-label-icons-data');
  if (!filterLabelIcon) { return false }
  let filterLabelIconData = JSON.parse(filterLabelIcon.innerHTML);
  if (typeof filterLabelIconData !== 'object') { return false }

  let filterLabels = document.querySelectorAll('[data-filter-label]');
  if (!filterLabels.length) { return false }

  filterLabels.forEach((filterLabel) => {
    let associatedData = filterLabelIconData.find(fli => fli.label === filterLabel.dataset.filterLabel);
    if (associatedData) {
      let icon = filterLabel.querySelector('img');
      if (icon) { return false }

      let img = document.createElement('img');
      img.src = associatedData.icon;
      img.alt = associatedData.label;

      filterLabel.prepend(img);
    }
  });
}

function createCookie(name, value, days) {
  let expires;
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  let cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (const element of cookieArr) {
    let cookiePair = element.split("=");

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
}

function setDataSizeTypeCookie() {
  let activeSizeTypeButton = document.querySelector(".active-size-type");
  if (!activeSizeTypeButton) {
    return false;
  }

  let active_size_type = activeSizeTypeButton.dataset.sizeType;
  if (typeof active_size_type !== "string") {
    return false;
  }

  createCookie("active_size_type", active_size_type, 1);
}

function setMoreColorsCookie($) {
  let moreColorsButton = document.querySelector("[data-more-colors-btn]");
  if (!moreColorsButton) {
    return false;
  }

  let more_colors_state = getCookie("more_colors_state") === "true";
  let windowWidth = window.innerWidth;
  if (windowWidth < 1024) {
    return false;
  }

  if (more_colors_state === null) {
    return createCookie("more_colors_state", true, 1);
  } else {
    createCookie("more_colors_state", !more_colors_state, 1);
  }
}

function checkForActiveSizeType($) {
  let active_size_type = getCookie("active_size_type");
  if (
    typeof active_size_type !== "string" &&
    (active_size_type !== "men" || active_size_type !== "women")
  ) {
    return false;
  }

  let activeSizeTypeButton = document.querySelector(
    `[data-size-type="${active_size_type}"]`
  );
  if (!activeSizeTypeButton) {
    return false;
  }

  activeSizeTypeButton.click();
}

function checkForMoreColorsCookie($) {
  let more_colors_state = getCookie("more_colors_state") === "true";
  let moreColorsButton = document.querySelector("[data-more-colors-btn]");

  if (!moreColorsButton || !more_colors_state) {
    return false;
  }

  let symbol = moreColorsButton.querySelector("span.btn-symbol");
  let label = moreColorsButton.querySelector("span.btn-label");
  let featuredImagesWrap = document.querySelector(".featured_images_wrap ");
  if (!symbol || !label || !featuredImagesWrap) {
    return false;
  }

  let windowWidth = window.innerWidth;
  if (windowWidth > 1023) {
    featuredImagesWrap.classList.add("full");
    symbol.innerHTML = "-";
    label.innerHTML = "Show Less";
  } else {
    featuredImagesWrap.classList.remove("full");
    symbol.innerHTML = "+";
    label.innerHTML = "Show More";
  }
}


// Ensure Add-to-Bag area price (including compare-at) updates on variant change
(function () {
  function getMoneyFormat() {
    try {
      var settings = window.themeVariables && window.themeVariables.settings;
      if (settings) {
        return settings.currencyCodeEnabled
          ? settings.moneyWithCurrencyFormat
          : settings.moneyFormat;
      }
    } catch (e) { }
    return "${{amount}}";
  }

  function formatMoneyCents(cents) {
    var format = getMoneyFormat();
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }
    if (typeof window.formatMoney === "function") {
      // Some themes expose a global formatMoney helper
      try { return window.formatMoney(cents, format); } catch (e) { }
    }
    // Basic fallback if helpers are unavailable
    var value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(?:_with_comma_separator|_no_decimals)?\s*\}\}/, value);
  }

  document.addEventListener(
    "variant:changed",
    function (event) {
      var variant = event && event.detail && event.detail.variant;
      var form = event && event.target;
      if (!form || !variant) return;

      var wrap = form.closest && form.closest(".product-form_wrap");
      if (!wrap) return;

      var priceSet = wrap.querySelector(
        ".add-to-bag_main_pro .display_price_set"
      );
      if (!priceSet) return;

      var priceEl = priceSet.querySelector(
        ".display_price_oncartbtn:not(.price--compare)"
      );
      if (priceEl) {
        priceEl.innerHTML = formatMoneyCents(variant.price);
      }

      var compareEl = priceSet.querySelector(
        ".display_price_oncartbtn.price--compare"
      );
      var hasCompare =
        variant.compare_at_price && variant.compare_at_price > variant.price;

      if (hasCompare) {
        if (!compareEl) {
          compareEl = document.createElement("div");
          compareEl.className = "display_price_oncartbtn price--compare";
          priceSet.appendChild(compareEl);
        }
        compareEl.style.display = "";
        compareEl.innerHTML = formatMoneyCents(variant.compare_at_price);
      } else if (compareEl) {
        // Hide compare-at when not applicable for selected variant
        compareEl.style.display = "none";
        compareEl.innerHTML = "";
      }
    },
    false
  );
})();

document.addEventListener(
  "variant:changed",
  function (event) {
    var variant = event && event.detail && event.detail.variant;
    syncPdpStickyCtaVariantTitle(variant);
  },
  false
);

$(function () {
  syncPdpStickyCtaMobileMeta();
});

/**
 * Shop by color carousel: toggles Colors facet checkboxes inside facet-filters and scroll UI.
 */
(function () {
  function findFacetColorCheckbox(paramName, value) {
    var facet = document.querySelector("facet-filters");
    if (!facet) return null;
    var form = facet.querySelector("#facet-filters-form");
    if (!form) return null;
    var inputs = form.querySelectorAll('input[type="checkbox"][name^="filter."]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (el.name === paramName && el.value === value) return el;
    }
    return null;
  }

  function setShopByColorLoading(root, loading) {
    if (!root) return;
    if (loading) {
      root.classList.add("shop-by-color--loading");
      root.setAttribute("aria-busy", "true");
    } else {
      root.classList.remove("shop-by-color--loading");
      root.removeAttribute("aria-busy");
    }
  }

  function clearAllShopByColorLoading() {
    document.querySelectorAll(".shop-by-color--loading").forEach(function (root) {
      root.classList.remove("shop-by-color--loading");
      root.removeAttribute("aria-busy");
    });
  }

  function toggleShopByColorFilter(button) {
    var paramName = button.getAttribute("data-filter-param-name");
    var value = button.getAttribute("data-filter-value");
    if (!paramName) return;
    var input = findFacetColorCheckbox(paramName, value);
    if (!input || input.disabled) return;
    window.__shopByColorFacetChange = true;
    window.__shopByColorPendingScrollSuppressions =
      (typeof window.__shopByColorPendingScrollSuppressions === "number"
        ? window.__shopByColorPendingScrollSuppressions
        : 0) + 1;
    input.checked = !input.checked;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    /* Optimistic selection state — server HTML will reconcile on render-complete */
    button.classList.toggle("is-active", input.checked);
  }

  /**
   * Theme sets facet-filters[open] after filter apply, which toggles lock-all on <html>.
   * That must be cleared or vertical scroll stays broken.
   * Do not clear __shopByColorFacetChange on a fixed timer: clearing before the facet
   * fetch finishes (e.g. un-selecting the last color reloads more HTML) lets
   * ProductFacet._rerender run scrollIntoView — theme.js checks this flag there.
   */
  function forceUnlockShopByColorScroll() {
    var ff = document.querySelector("facet-filters");
    if (ff) ff.removeAttribute("open");
    document.documentElement.classList.remove("lock-all");
  }

  function scheduleShopByColorScrollUnlock() {
    if (!window.__shopByColorFacetChange) return;
    forceUnlockShopByColorScroll();
    requestAnimationFrame(function () {
      forceUnlockShopByColorScroll();
      requestAnimationFrame(forceUnlockShopByColorScroll);
    });
    [50, 150, 300, 500, 800, 1200].forEach(function (ms) {
      setTimeout(forceUnlockShopByColorScroll, ms);
    });
  }

  function updateShopByColorArrows(root) {
    if (!root) return;
    var track = root.querySelector("[data-shop-by-color-track]");
    var prev = root.querySelector("[data-shop-by-color-prev]");
    var next = root.querySelector("[data-shop-by-color-next]");
    if (!track || !prev || !next) return;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var sl = track.scrollLeft;
    prev.disabled = sl <= 2;
    next.disabled = sl >= maxScroll - 2;
    root.classList.toggle("shop-by-color--can-scroll-left", !prev.disabled);
    root.classList.toggle("shop-by-color--can-scroll-right", !next.disabled);
  }

  function bindShopByColorTrackScroll(root) {
    var track = root.querySelector("[data-shop-by-color-track]");
    if (!track || track._shopByColorScrollBound) return;
    track._shopByColorScrollBound = true;
    track.addEventListener(
      "scroll",
      function () {
        updateShopByColorArrows(root);
      },
      { passive: true }
    );
  }

  function initAllShopByColorCarousels() {
    document.querySelectorAll("[data-shop-by-color]").forEach(function (root) {
      bindShopByColorTrackScroll(root);
      updateShopByColorArrows(root);
    });
  }

  var shopByColorResizeTimer;
  function onShopByColorResize() {
    clearTimeout(shopByColorResizeTimer);
    shopByColorResizeTimer = setTimeout(initAllShopByColorCarousels, 100);
  }

  function saveShopByColorTrackScroll(button) {
    var root = button.closest("[data-shop-by-color]");
    var track = root && root.querySelector("[data-shop-by-color-track]");
    if (track) {
      window.__shopByColorSavedScrollLeft = track.scrollLeft;
    }
  }

  $(document).on("click", "[data-shop-by-color-trigger]", function (e) {
    e.preventDefault();
    if (this.disabled || this.getAttribute("aria-disabled") === "true") return;
    var root = this.closest("[data-shop-by-color]");
    saveShopByColorTrackScroll(this);
    setShopByColorLoading(root, true);
    toggleShopByColorFilter(this);
  });

  $(document).on("keydown", "[data-shop-by-color-trigger]", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();
    if (this.disabled) return;
    var root = this.closest("[data-shop-by-color]");
    saveShopByColorTrackScroll(this);
    setShopByColorLoading(root, true);
    toggleShopByColorFilter(this);
  });

  /* facet:criteria-changed runs before the section HTML swap; init after fetch in theme:loading:end */
  function restoreShopByColorTrackScroll() {
    if (typeof window.__shopByColorSavedScrollLeft !== "number") return;
    var saved = window.__shopByColorSavedScrollLeft;
    delete window.__shopByColorSavedScrollLeft;
    function apply() {
      document.querySelectorAll("[data-shop-by-color-track]").forEach(function (track) {
        track.scrollLeft = saved;
      });
      document.querySelectorAll("[data-shop-by-color]").forEach(function (root) {
        updateShopByColorArrows(root);
      });
    }
    requestAnimationFrame(function () {
      apply();
      setTimeout(apply, 50);
      setTimeout(apply, 200);
    });
  }

  /* Any loading end may replace DOM; re-bind carousel. Do not tie scroll-suppress / unlock to this — other
     bars call theme:loading:end and would clear state before ProductFacet._rerender runs (random scroll). */
  document.addEventListener("theme:loading:end", function () {
    initAllShopByColorCarousels();
  });

  document.addEventListener("product-facet:render-complete", function () {
    clearAllShopByColorLoading();
    initAllShopByColorCarousels();
    if (!window.__shopByColorFacetChange) return;
    scheduleShopByColorScrollUnlock();
    restoreShopByColorTrackScroll();
    window.__shopByColorFacetChange = false;
  });

  $(document).on("click", "[data-shop-by-color-prev]", function (e) {
    e.preventDefault();
    if (this.disabled) return;
    var root = this.closest("[data-shop-by-color]");
    var track = root && root.querySelector("[data-shop-by-color-track]");
    if (!track) return;
    var w = Math.min(320, track.clientWidth * 0.85);
    track.scrollBy({ left: -w, behavior: "smooth" });
  });

  $(document).on("click", "[data-shop-by-color-next]", function (e) {
    e.preventDefault();
    if (this.disabled) return;
    var root = this.closest("[data-shop-by-color]");
    var track = root && root.querySelector("[data-shop-by-color-track]");
    if (!track) return;
    var w = Math.min(320, track.clientWidth * 0.85);
    track.scrollBy({ left: w, behavior: "smooth" });
  });

  $(function () {
    initAllShopByColorCarousels();
  });

  document.addEventListener("facet:criteria-changed", function () {
    requestAnimationFrame(initAllShopByColorCarousels);
    /* If loading:end is missed (race / abort), still release scroll lock */
    if (!window.__shopByColorFacetChange) return;
    setTimeout(function () {
      if (!window.__shopByColorFacetChange) return;
      clearAllShopByColorLoading();
      scheduleShopByColorScrollUnlock();
      window.__shopByColorFacetChange = false;
    }, 1100);
  });

  document.addEventListener("shopify:section:load", function () {
    initAllShopByColorCarousels();
  });

  window.addEventListener("resize", onShopByColorResize);
})();
